<template>
  <div>
    <div class="card-body">
      <b-row>
        <b-col md="6">
          <b-form-group label="Descrição" label-for="descricao">
            <b-form-input
              id="descricao"
              v-model="$v.form.descricao.$model"
              :state="validateState('descricao')"
              autofocus
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Status" label-for="status">
            <span class="switch switch-icon">
              <label>
                <input id="status" type="checkbox" v-model="form.status" />
                <span></span>
              </label>
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-v="center">
        <b-col md="7">
          <b-form-group label="Serviço" label-for="servico">
            <VueSelect
              id="servico"
              ref="buscarServico"
              :filterable="false"
              :options="servicosFetched"
              @search="onSearchServico"
              @input="setServico"
              v-model="servicoSelected"
              label="discriminacao"
            >
              <template slot="no-options">
                Busque o serviço pela descrição
              </template>
              <template slot="option" slot-scope="option">
                {{ option.discriminacao }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.discriminacao }}
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Preço da lista R$" label-for="preco_lista">
            <money
              id="preco_lista"
              class="form-control"
              v-model="precoLista"
              v-bind="priceOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <button
            class="btn btn-info btn-hover-dark font-weight-bolder mt-8"
            type="button"
            @click="addServico"
          >
            Adicionar
          </button>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <TableApp
            item="serviço"
            titulo="Serviços da lista"
            subTitulo=""
            :data="servicos"
            :fields="fields"
            classFilterColumn="discriminacao"
            :key="keyToRender"
          >
            <template slot="customRow" scope="props">
              <span
                slot="discriminacao"
                v-if="props.field === 'discriminacao'"
                class="font-weight-bold text-muted"
              >
                {{ props.rowData.discriminacao }}
              </span>
              <span
                slot="preco_lista"
                v-if="props.field === 'preco_lista'"
                class="text-dark-75 font-weight-bolder"
              >
                R$ {{ numberToReal(props.rowData.preco_lista, "preco") }}
              </span>
              <span slot="actions" v-if="props.field === 'actions'">
                <button
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon"
                  type="button"
                  @click="removerServico(props.rowData.id_servico)"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </span>
            </template>
          </TableApp>
        </b-col>
      </b-row>
    </div>

    <div class="card-footer text-center">
      <button
        type="button"
        ref="submit_lista_preco_servico"
        class="btn btn-primary font-weight-bold"
        @click="salvarLista"
      >
        Salvar
      </button>
      <router-link
        class="btn btn-clean font-weight-bold"
        :to="{ name: 'listaPrecosServicos' }"
      >
        Cancelar
      </router-link>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
import VueSelect from "vue-select";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table3.vue";
import { Money } from "v-money";
import { priceOptions, SistemaMixin } from "@/modules/Application";

export default {
  name: "app-lista-preco-servico-form",
  components: {
    VueSelect,
    TrashCanIcon,
    TableApp,
    Money,
  },
  mixins: [validationMixin, SistemaMixin],
  props: {
    url: {
      type: String,
      required: true,
    },
    lista: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      priceOptions,
      form: {
        descricao: null,
        status: true,
      },
      servicoSelected: null,
      precoLista: 0,
      servicosFetched: [],
      servicos: [],
      keyToRender: 0,
      fields: [
        {
          label: "Serviço",
          field: "discriminacao",
          slot: true,
          sortable: false,
          width: "60%",
          filterOptions: { enabled: false },
        },
        {
          label: "Preço",
          field: "preco_lista",
          slot: true,
          sortable: false,
          width: "25%",
          filterOptions: { enabled: false },
        },
        {
          label: "",
          field: "actions",
          slot: true,
          sortable: false,
          width: "15%",
          filterOptions: { enabled: false },
        },
      ],
    };
  },
  validations: {
    form: {
      descricao: { required },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSearchServico(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchServicos(loading, search, this);
      }
    },
    searchServicos: _.debounce(async (loading, search, vm) => {
      try {
        const { data } = await vm.$http.post("/servicos/filter", {
          discriminacao: search,
        });
        vm.servicosFetched = [...data];
      } finally {
        loading(false);
      }
    }, 350),
    setServico(servico) {
      this.precoLista = servico ? Number(servico.valor || 0) : 0;
    },
    addServico() {
      if (!this.servicoSelected || Number(this.precoLista) <= 0) {
        this.$toast.error("Selecione um serviço e informe um preço válido!");
        return;
      }

      if (
        this.servicos.some(
          (servico) => servico.id_servico === this.servicoSelected.id_servico
        )
      ) {
        this.$toast.error("Este serviço já está na lista!");
        return;
      }

      this.servicos.push({
        ...this.servicoSelected,
        preco_lista: Number(this.precoLista),
      });
      this.servicoSelected = null;
      this.precoLista = 0;
      this.keyToRender += 1;
    },
    removerServico(idServico) {
      this.servicos = this.servicos.filter(
        (servico) => servico.id_servico !== idServico
      );
      this.keyToRender += 1;
    },
    async salvarLista() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        this.$toast.error(
          "Verifique todos os campos obrigatórios do formulário!"
        );
        return;
      }

      if (this.servicos.length === 0) {
        this.$toast.error("Insira ao menos um serviço na lista!");
        return;
      }

      this.addLoadingToButton("submit_lista_preco_servico");
      try {
        await this.$http.post(this.url, {
          ...this.form,
          servicos: this.servicos.map(
            ({ id_servico, discriminacao, preco_lista }) => ({
              id_servico,
              discriminacao,
              preco_lista,
            })
          ),
          ...(this.lista.id_lista_preco_servico && {
            id_lista_preco_servico: this.lista.id_lista_preco_servico,
          }),
        });
        this.$router.push({ name: "listaPrecosServicos" });
      } finally {
        this.removeLoadingToButton("submit_lista_preco_servico");
      }
    },
    preencherLista(lista) {
      if (!lista || !lista.id_lista_preco_servico) return;

      this.form.descricao = lista.descricao;
      this.form.status = lista.status;
      this.servicos = (lista.servicos || []).map((servico) => ({
        ...servico,
        preco_lista: servico.pivot.preco_lista,
      }));
      this.keyToRender += 1;
    },
  },
  watch: {
    lista: {
      immediate: true,
      handler(value) {
        this.preencherLista(value);
      },
    },
  },
};
</script>
